import { useNavigate } from 'react-router-dom';

const WHATSAPP_URL = 'https://wa.me/5511913278081?text=Ol%C3%A1%2C%20preciso%20de%20atendimento%20jur%C3%ADdico%20urgente.';

const links = [
  { label: 'Início', href: '/' },
  { label: 'Área de Atuação', href: '/atuacao' },
  { label: 'Criminal', href: '/atuacao/criminal' },
  { label: 'Penal Empresarial', href: '/atuacao/penal-empresarial' },
  { label: 'Civil', href: '/atuacao/civil' },
  { label: 'Blog', href: '/blog' },
];

const servicos = [
  'Direito Penal',
  'Penal Empresarial',
  'Direito Civil',
  'Defesa Criminal',
  'Habeas Corpus',
  'Tribunal do Júri',
  'Compliance Criminal',
  'Responsabilidade Civil',
];

export default function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="bg-[#060E18] text-white">
      {/* CTA Banner */}
      <div className="bg-[#B39B62]/10 border-t border-b border-[#B39B62]/20">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-10 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <h3 className="font-serif text-2xl text-white font-light mb-1">
              Precisa de <span className="italic text-[#B39B62]">assessoria jurídica agora?</span>
            </h3>
            <p className="font-sans text-white/50 text-sm">Soluções estratégicas para pessoas e empresas.</p>
          </div>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-[#B39B62] hover:bg-[#E9D59C] text-[#0A1829] font-sans font-semibold text-sm px-8 py-4 rounded-md transition-all duration-300 cursor-pointer whitespace-nowrap shrink-0"
          >
            <i className="ri-whatsapp-line text-lg"></i>
            Falar no WhatsApp
          </a>
        </div>
      </div>

      {/* Main footer */}
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <img
              src="https://static.readdy.ai/image/2751d92eb47f633f00285d5acf7c03f9/40cf0716b403846660cfdfa832bad018.png"
              alt="Moreira Tófoli Advogados"
              className="h-12 w-auto mb-5"
            />
            <p className="font-sans text-white/40 text-sm leading-relaxed mb-5">
              Assessoria jurídica completa em Direito Penal, Penal Empresarial e Direito Civil.
            </p>
            <div className="flex items-center gap-3">
              <a
                href="https://instagram.com/advogados.moreiratofoli"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-white/15 hover:border-[#B39B62] hover:text-[#B39B62] text-white/50 transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-sm"></i>
              </a>
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-white/15 hover:border-[#B39B62] hover:text-[#B39B62] text-white/50 transition-colors cursor-pointer"
              >
                <i className="ri-whatsapp-line text-sm"></i>
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-sans text-xs font-semibold text-[#B39B62] tracking-[0.2em] uppercase mb-5">
              <a id="nav-footer">Navegação</a>
            </h4>
            <ul className="space-y-3">
              {links.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => { e.preventDefault(); navigate(link.href); }}
                    className="font-sans text-sm text-white/50 hover:text-[#B39B62] transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Serviços */}
          <div>
            <h4 className="font-sans text-xs font-semibold text-[#B39B62] tracking-[0.2em] uppercase mb-5">
              <a id="services-footer">Atuação</a>
            </h4>
            <ul className="space-y-3">
              {servicos.map((s) => (
                <li key={s}>
                  <a
                    href="/atuacao"
                    onClick={(e) => { e.preventDefault(); navigate('/atuacao'); }}
                    className="font-sans text-sm text-white/50 hover:text-[#B39B62] transition-colors cursor-pointer"
                  >
                    {s}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contato */}
          <div>
            <h4 className="font-sans text-xs font-semibold text-[#B39B62] tracking-[0.2em] uppercase mb-5">
              <a id="contact-footer">Contato</a>
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-[#B39B62] text-sm mt-0.5"></i>
                <span className="font-sans text-sm text-white/50 leading-relaxed">
                  Av. Marquês de São Vicente, 121<br />Barra Funda, São Paulo/SP
                </span>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-whatsapp-line text-[#B39B62] text-sm"></i>
                <a
                  href={WHATSAPP_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-sans text-sm text-white/50 hover:text-[#B39B62] transition-colors cursor-pointer whitespace-nowrap"
                >
                  (11) 91327-8081
                </a>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-instagram-line text-[#B39B62] text-sm"></i>
                <a
                  href="https://instagram.com/advogados.moreiratofoli"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="font-sans text-sm text-white/50 hover:text-[#B39B62] transition-colors cursor-pointer"
                >
                  @advogados.moreiratofoli
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-center">
          <p className="font-sans text-xs text-white/25">
            © {new Date().getFullYear()} Moreira Tófoli Advogados. CNPJ: 55.698.662/0001-79. Todos os direitos reservados.
          </p>
          <p className="font-sans text-xs text-white/30">
            Desenvolvido por{' '}
            <a
              href="https://startdigital1.com.br"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="text-[#B39B62]/60 hover:text-[#B39B62] transition-colors cursor-pointer"
            >
              Start Digital
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
